<div class="dialog-header">
  <div class="header-content">
    <div class="header-icon">
      <mat-icon>download</mat-icon>
    </div>
    <div class="header-text">
      <h2 mat-dialog-title>
        {{ 'createDoc.tdDownloadDialog.title' | transloco }}
      </h2>
      <p class="header-subtitle">
        {{ data.fileCount }} {{ filePluralLabel }}
        {{ 'createDoc.tdDownloadDialog.messageOf' | transloco }}
        {{ documentTypeLabel }}
      </p>
    </div>
  </div>
  <button mat-icon-button color="primary"
    (click)="onCancel()" type="button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="file-card">
    <div class="file-icon">
      <mat-icon>folder_zip</mat-icon>
    </div>
    <div class="file-details">
      <div class="file-name">{{ data.fileName }}</div>
      <div class="file-meta">
        {{ data.fileCount }}
        {{ 'createDoc.tdDownloadDialog.fileMetaSuffix' | transloco }}
        · {{ formattedFileSize }}
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button type="button" (click)="onSaveToDataspace()">
    {{ 'createDoc.tdDownloadDialog.saveToDatasetButton' | transloco }}
  </button>
  <button mat-raised-button color="primary" type="button" (click)="onDownload()">
    <mat-icon>download</mat-icon>
    {{ 'createDoc.tdDownloadDialog.downloadButton' | transloco }}
  </button>
</mat-dialog-actions>
